import React from 'react'
import {  Navbar, Nav, Button } from 'react-bootstrap';
import logo from './logo10.jpg';

function header() {
  return (
    
    <Navbar  style={{ padding: '0' }}  bg="dark" variant="dark" expand="lg" className="px-4">
      
        <Navbar.Brand href="/"> 
          <img
                  src={logo}
                  alt="logo"
                  style={{ height: '80px', width: 'auto' }}
                /></Navbar.Brand>
                    <Nav className="me-auto">
          <Button  href="/login" variant="light">אזור אישי</Button>
        </Nav>

      </Navbar>
  )
}

export default header